/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { MdSwapHoriz } from 'react-icons/md';

import PropTypes from 'prop-types';
import * as qs from 'query-string';
import { useQueryState } from 'use-location-state';

import { Tab, Tabs, Popover } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import CardSideBordered from '~/components/CardSideBordered';
import LocaleMessage from '~/components/LocaleMessage';
import Splash from '~/components/Splash/Inside';

import Page404 from '~/pages/Open/Page404';
import api from '~/services/pluginbot-api';

import MapNavigation from './MapNavigation';
import Settings from './Settings';
import Timing from './Timing';
import Visual from './Visual';

const useStyles = makeStyles(theme => {
    return {
        root: {
            flexGrow: 1,
            backgroundColor: theme.palette.background.paper,
            display: 'flex',
        },
        tabs: {
            marginTop: '10px',
            borderRight: `1px solid ${theme.palette.divider}`,
            textAlign: 'left',
            height: '100%',
        },
    };
});

const available_settings = [
    // {
    //     value: 'settings',
    //     label: (
    //         <LocaleMessage msg="label.settings.app.indoor_delivery.settings" />
    //     ),
    // },
    // {
    //     value: 'language',
    //     label: (
    //         <LocaleMessage msg="label.settings.app.indoor_delivery.language" />
    //     ),
    // },
    {
        value: 'map_navigation',
        label: (
            <LocaleMessage msg="label.settings.app.indoor_delivery.map_navigation" />
        ),
    },
    {
        value: 'timing',
        label: (
            <LocaleMessage msg="label.settings.app.indoor_delivery.timing" />
        ),
    },
    {
        value: 'visual',
        label: (
            <LocaleMessage msg="label.settings.app.indoor_delivery.visual" />
        ),
    },
];

const pages = {
    settings: Settings,
    language: Settings,
    map_navigation: MapNavigation,
    timing: Timing,
    visual: Visual,
};

export default function IndoorDeliveryApp({
    setToast,
    appSettings,
    updateObject,
    location,
}) {
    const classes = useStyles();
    const { robot_types, group } = appSettings;
    const group_id = group ? group.id : '*';

    const { search } = location;
    const query = qs.parse(search);

    const [queryTab, setQueryTab] = useQueryState(
        'tab',
        available_settings[0].value
    );
    const [queryRobotType, setQueryRobotType] = useQueryState('robot_type', '');

    const [value, setValue] = useState(query && query.tab ? query.tab : null);
    const [currType, setCurrType] = useState(robot_types[0]);

    const [isLoading, setIsLoading] = useState(false);
    const [imageGalleriesList, setImageGalleriesList] = useState([]);
    const [needSaving, setNeedSaving] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const tooltipOpen = Boolean(anchorEl);

    const handleChangeTab = (event, newValue) => {
        if (needSaving && newValue !== value) {
            setAnchorEl(event.currentTarget);
            return;
        }
        if (!needSaving) {
            setValue(newValue);

            if (search !== newValue) {
                setQueryTab(newValue);
            }
        }
    };

    function requestError(error) {
        if (error.response) {
            const message = (
                <LocaleMessage msg={`errors.${error.response.data.code}`} />
            );
            setToast({
                color: 'error',
                body: message,
            });
        } else if (error.request) {
            setToast({
                color: 'error',
                body: <LocaleMessage msg="errors.request" />,
            });
        } else {
            setToast({
                color: 'error',
                body: <LocaleMessage msg="errors.unknown" />,
            });
        }
        setIsLoading(false);
    }

    async function loadGalleryList() {
        await api
            .get(`albums?type=images`)
            .then(async response => {
                const filtered = response.data.filter(g => {
                    return (
                        g.group &&
                        (g.group.id === '*' || g.group.id === group_id)
                    );
                });
                setImageGalleriesList(filtered);
            })
            .catch(error => requestError(error));
    }

    async function loadSettings() {
        let v = available_settings[0].value;
        if (queryTab) {
            v = queryTab;
        }
        setValue(v);
    }

    useEffect(() => {
        loadSettings();
    }, []);

    useEffect(() => {
        loadGalleryList();
    }, []);

    useEffect(() => {
        const r_type = robot_types.find(r => {
            return r.id === queryRobotType;
        });
        setCurrType(r_type || robot_types[0]);
    }, [queryRobotType]);

    const handleChangeRobot = newValue => {
        setQueryRobotType(newValue);
    };

    function renderOptions() {
        const currTab = available_settings.find(t => {
            return t.value === value;
        });

        const firstTab = available_settings[0]
            ? available_settings[0].value
            : '';

        return (
            <div className="col-md-2 col-12">
                <Tabs
                    indicatorColor="primary"
                    orientation="vertical"
                    value={currTab ? value : firstTab}
                    onChange={handleChangeTab}
                    className={classes.tabs}
                    centered
                >
                    {available_settings.map(s => {
                        return (
                            <Tab
                                key={s.value}
                                label={s.label}
                                value={s.value}
                            />
                        );
                    })}
                </Tabs>
            </div>
        );
    }

    function renderInternalPage(page) {
        const Page = pages[page] || Page404;
        return (
            <div className="col-md-10 col-12 row" style={{ flex: 1 }}>
                <Page
                    group={group_id}
                    robotTypes={robot_types}
                    currType={currType}
                    setCurrType={r => {
                        const r_id = r ? r.id : '';
                        handleChangeRobot(r_id);
                    }}
                    app={appSettings}
                    updateObject={data => updateObject(data)}
                    imageGalleriesList={imageGalleriesList}
                    setToast={message => setToast(message)}
                    handleError={error => requestError(error)}
                    handleChangeTab={(e, v) => handleChangeTab(e, v)}
                    needSaving={needSaving}
                    setNeedSaving={s => setNeedSaving(s)}
                />
            </div>
        );
    }

    return (
        <div className="col-12 mb-5 mt-5">
            {isLoading ? (
                <Splash />
            ) : (
                <CardSideBordered
                    title={
                        <LocaleMessage msg="page.applications.indoor_delivery.title" />
                    }
                    Icon={MdSwapHoriz}
                    hide
                >
                    <div className={`sidecard-body ${classes.root} col-12 row`}>
                        {tooltipOpen ? (
                            <Popover
                                open={tooltipOpen}
                                anchorEl={anchorEl}
                                onClose={() => setAnchorEl(null)}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                            >
                                <div style={{ padding: '15px' }}>
                                    <LocaleMessage msg="message.need_save.content" />
                                </div>
                            </Popover>
                        ) : null}

                        {renderOptions()}
                        {renderInternalPage(value)}
                    </div>
                </CardSideBordered>
            )}
        </div>
    );
}

IndoorDeliveryApp.propTypes = {
    appSettings: PropTypes.object.isRequired,
    updateObject: PropTypes.func.isRequired,
    setToast: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
};
